import { RatesLayout, RatesList } from '@/views/rates';

export default {
  path: 'rates',
  name: 'rates',
  component: RatesList,
  meta: {
    authRequired: 'true',
    groups: ['admin', 'standard']
  }




/*
  children: [
    { path: '', redirect: { name: 'invoices_list' } },
    { path: 'list', name: 'invoices_list', component: List },
    {
      path: 'rates',
      name: 'rates',
      component: RatesList,
      meta: {
        authRequired: 'true',
        groups: ['admin', 'standard']
      },
    }
    // { path: 'add', component: AddEdit },
    // { path: 'edit/:id', component: AddEdit }
  ]*/
}
